import RtModule from "@/utils/RtModule";

class _FormsAI{
    constructor() {
        this.formLabelsCache = new Map();
    }

    /**
     * @param {FormConfig} formConfig
     * @param entity
     */
    getEntityLabel(formConfig, entity){
        if(!formConfig){
            formConfig = FormsLoader.detectFormConfig(entity);
        }
        if(entity === null || entity === undefined){
            return formConfig.entityName;
        }
        if(this.formLabelsCache.has(formConfig.formClassLong)){
            return this.formLabelsCache.get(formConfig.formClassLong).call(this, entity);
        }

        let partsOfLabel = [];
        for(const field of formConfig.fields){
            if(field.entityLabel){
                const idx = field.fieldName;
                this.formLabelsCache.set(formConfig.formClassLong, function(ent){
                    let labelFunctionName = "get" + idx[0].toUpperCase() + idx.substr(1) + "StaticLabel";
                    if(ent[labelFunctionName]){
                        return ent[labelFunctionName]();
                    }
                    return ent[idx];
                });

                return this.getEntityLabel(formConfig, entity);
            }

            if(field.partOfEntityLabel >= 0){
                partsOfLabel.push({ order: field.partOfEntityLabel, fieldName: field.fieldName })
            }
        }

        if(partsOfLabel.length > 0){
            partsOfLabel.sort((a, b) => {
                return a.order - b.order;
            })

            const indices = partsOfLabel;
            const labelFun = function(ent){
                let nonEmpty = [];
                for(const field of indices){
                    let labelFunctionName = "get" + field.fieldName[0].toUpperCase() + field.fieldName.substr(1) + "StaticLabel";
                    if(ent[labelFunctionName]){
                        nonEmpty.push(ent[labelFunctionName]());
                        continue;
                    }
                    let fieldVal = ent[field.fieldName];
                    if(fieldVal){
                        nonEmpty.push(fieldVal);
                    }
                }
                return nonEmpty.join(" | ");
            }
            this.formLabelsCache.set(formConfig.formClassLong, labelFun);
            return labelFun(entity);
        }

        if(formConfig.entityLabelFunction){
            this.formLabelsCache.set(formConfig.formClassLong,
                function(inst){
                    return RtModule()[formConfig.entityLabelFunction].call(inst, inst, formConfig);
                });

            return RtModule()[formConfig.entityLabelFunction].call(entity, entity, formConfig);
        }

        const nameCandidates = ["name", "title", "label", "number", "eid", "id"]
        for(const candidate of nameCandidates) {
            for (const field of formConfig.fields) {
                if (field.fieldName.toLowerCase() === candidate) {

                    const idx = field.fieldName;
                    this.formLabelsCache.set(formConfig.formClassLong, function(ent){
                        return ent[idx];
                    });

                    return entity[idx];
                }
            }
        }
        this.formLabelsCache.set(formConfig.formClassLong, function(ent){
            return "";
        });
        return "";
    }

    /**
     * @param {FormConfig} formConfig
     * @param entity
     */
    getBelowTheLabel(formConfig, entity){
        if(formConfig.textBelowTheListFunction){
            return RtModule()[formConfig.textBelowTheListFunction].call(entity, entity, formConfig);
        }
    }
}

const FormsAI = new _FormsAI();
export default FormsAI;
